import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type GroundingMenuSlots = {
  root: Slot<'div'>;
};

/**
 * GroundingMenu Props
 */
export type GroundingMenuProps = ComponentProps<GroundingMenuSlots> & {};

/**
 * State used in rendering GroundingMenu
 */
export type GroundingMenuState = ComponentState<GroundingMenuSlots>;
// TODO: Remove semicolon from previous line, uncomment next line, and provide union of props to pick from GroundingMenuProps.
// & Required<Pick<GroundingMenuProps, 'propName'>>
